import React, { useEffect } from "react";
import "./newtopic.css";
import { Form, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../../components/common/alert";
// import {
//   ChangeSubjectConfirmDirty,
//   ChangeSubjectTableData,
//   ChangeSubjectModalState,
// } from "../../../actions/adminAction";
import { changeSubjectModalState, } from "../../../reducers/admin";
import { fetchSubjectTableData } from "../../../features/adminAsync";
const NewTopics = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const admin = useSelector((state) => state.admin);
  const { SubjectId, subjectDetails, Subjectmode } = admin;
  //  console.log(subjectDetails,SubjectId,Subjectmode);
  

  // useEffect(() => {
  //   // Set initial form values when subjectDetails changes
  //   form.setFieldsValue({ topic: subjectDetails.topic });
  // }, [subjectDetails, form]);

  const handleSubmit = (values) => {
    SecurePost({
      url: `${apis.CREATE_SUBJECT}`,
      data: {
        _id: SubjectId,
        topic: values.topic,
      },
    })
      .then((response) => {
        dispatch(changeSubjectModalState(false, null, "New Topic"));
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchSubjectTableData());
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        dispatch(changeSubjectModalState(false, null, "New Topic"));
        const message = error.response?.data?.message || error.message;
        Alert("error", "Error!", message);
      });
  };

  return (
    <div className="register-subject-form">
      <div className="register-trainer-form-body">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          // initialValues={{ topic: subjectDetails.topic }}
        >
          <Form.Item
            label="Topic Name"
            name="topic"
            className="input-admin-trainer"
            rules={[
              {
                required: true,
                message: "Please input topic name!",
                whitespace: true,
              },
            ]}
            hasFeedback
          >
            <Input autoFocus />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {Subjectmode}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default NewTopics;
